import React from "react";
import { Route, RouteComponentProps, withRouter } from "react-router-dom";

import { route } from "@/configs/route.configs";

import DashboardApp from "@/components/MainFlow/Dashboard/DashboardApp";
import SalaryManagementApp from "@/components/MainFlow/SalaryManagement/SalaryManagementApp";

const Router: React.FC<RouteComponentProps> = () => {
  return (
    <>
      {/* Dashboard Page */}
      <Route exact path={route.dashboard.path} component={DashboardApp} />
      {/* Plan Page */}
      {/*<Route path={route.plan.path} component={PlanApp} />*/}
      {/* Point Page */}
      {/*<Route path={route.point.path} component={PointApp} />*/}
      {/* Manager Page */}
      {/*<Route path={route.manager.path} component={ManagerApp} />*/}
      {/* Invite Page */}
      {/*<Route path={route.invite.path} component={InviteApp} />*/}
      {/* Salary Management */}
      <Route
        path={route.salaryManagement.path}
        component={SalaryManagementApp}
      />
      {/* Payment Integration Page */}
      {/*<Route*/}
      {/*  path={route.paymentIntegration.path}*/}
      {/*  component={PaymentIntegration}*/}
      {/*/>*/}
      {/* Download Page */}
      {/*<Route path={route.download.path} component={DownloadApp} />*/}
    </>
  );
};

export default withRouter(Router);
